import {useParams} from 'react-router-dom';
import styled from "styled-components";
import Main from '../../../components/main';
import CommunityHeader from "../../../components/community_header";
import {useBottomBar} from "../../../app_context";
import {useBaseCommunity} from '../../../store';
import useFeedback from "../../../utils/use_feedback";
import {useWikiIndex} from "../../../api/wiki";
import useModal from "../../../modals";
import {useCommunities} from "../../../api/communities";

const About = styled.div``;
const Topics = styled.div``;
const Heading = styled.div``;

const Item = styled.div``;
const Title = styled.div``;

const WikiList = styled(({wikis, className}) => {
    const modal = useModal();
    return (
        <div className={className}>
            {wikis?.map((wiki, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Item key={index} onClick={() => modal.open('Wiki', {wiki})}>
                    <Title>
                        {wiki.page_name}
                    </Title>
                </Item>
            ))}
            {wikis.length === 0 && <>This community does not have a wiki yet.</>}
        </div>
    );
})`
  color: ${({theme}) => theme.menu.color};
  font-size: 15px;
  ${Item} {
    padding: 8px 0;
  }
`;

const WikiCommunity = styled(({className}) => {

    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const {error, feedbackCh} = useFeedback();
    const communityInfo = useCommunities(feedbackCh, [paramsCommunity])[0] || false;
    const wikis = useWikiIndex(feedbackCh, community);
    useBottomBar();

    return (
        <>
            <CommunityHeader community={communityInfo}/>
            <Main>
                <About className={className}>
                    <Heading><h2>Community Wiki</h2></Heading>
                    {wikis && (
                        <WikiList community={community} wikis={wikis} error={error} />
                    )}
                 </About>
            </Main>
        </>
    );
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? 'none' : theme.white_0};
  margin-top: 8px;
  padding: 0 20px;
  padding-bottom: 16px;

  ${Heading} {
    display: flex;
    align-items: center;
    padding-top: 16px;
    padding-bottom: 4px;
  }
  ${Heading} h2 {
    font-size: 17px !important;
  }

  ${Heading} a {
    margin-left: auto;
    cursor: pointer;
  }
  
  p {
    font-size: 16px;
  }

  svg {
    margin-right: 4px;
  }

  ${Topics} > * {
    margin-right: 4px;
    margin-bottom: 4px;
  }

  ${Topics} {
    margin: 12px 0;
  }`;

export default WikiCommunity;
